import { Container, Graphics } from 'pixi.js';

export interface FallingParticleConfig {
    x: number;
    y: number;
    size: number;
    color: number;
    alpha: number;
    speed: number;
    drift: number;
    driftPhase?: number;
    baseAlpha?: number;
    wobblePhase?: number;
}

/**
 * Reusable system for particles that fall and drift laterally, 
 * wrapping around the screen edges (Snowflakes, Petals, etc.).
 */
export class FallingParticle {
    public gfx: Graphics;
    public x: number;
    public y: number;
    public speed: number;
    public drift: number;
    public driftPhase: number;
    public size: number;
    public baseAlpha: number;
    public wobblePhase: number;

    constructor(container: Container, config: FallingParticleConfig) {
        this.gfx = new Graphics();
        this.gfx.circle(0, 0, config.size);
        this.gfx.fill({ color: config.color, alpha: config.alpha });
        this.gfx.x = config.x;
        this.gfx.y = config.y;

        container.addChild(this.gfx);

        this.x = config.x;
        this.y = config.y;
        this.size = config.size;
        this.speed = config.speed;
        this.drift = config.drift;
        this.driftPhase = config.driftPhase ?? Math.random() * Math.PI * 2;
        this.baseAlpha = config.baseAlpha ?? config.alpha;
        this.wobblePhase = config.wobblePhase ?? 0;
    }

    update(dt: number, elapsed: number, screenW: number, screenH: number): void {
        this.y += this.speed * dt;
        this.x += Math.sin(elapsed * 0.8 + this.driftPhase) * this.drift * dt;

        // Wrap falling particles
        if (this.y > screenH + 10) {
            this.y = -10;
            this.x = Math.random() * screenW;
        }
        if (this.x < -20) this.x = screenW + 10;
        if (this.x > screenW + 20) this.x = -10;

        this.gfx.x = this.x;
        this.gfx.y = this.y;
    }

    destroy(): void {
        this.gfx.destroy();
    }
}
